module.exports = __webpack_public_path__ + "static/media/hero.b6271d86.jpg";